import { useEffect } from "react";
import { Link } from "react-router-dom";
import "../licence.css";

export default function InfrastructureLicence() {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = "Infrastructure Licence | DEV4";
        return () => {
            document.title = previousTitle;
        };
    }, []);

    return (
        <main className="below-navbar d4-container licence-page">
            <article aria-labelledby="infrastructure-licence-title">
                <p><Link to="/licence">All licences</Link></p>
                <h1 id="infrastructure-licence-title">Infrastructure Licence</h1>
                <p>Select a version to view the licence agreement.</p>
                <ul>
                    <li><Link to="/licence/infrastructure/v1">Version 1.0</Link></li>
                </ul>
            </article>
        </main>
    );
}
